<div
  class="document-field"
  [class.document-field--can-drop]="canEdit"
  (dragenter.capture)="onHostDragEnterCapture($any($event))"
  (dragover.capture)="onHostDragOverCapture($any($event))"
  (drop.capture)="onHostDropCapture($any($event))"
  (dragend.capture)="onHostDragEndCapture()">
  <div class="expandable-text-probe" appExpandableText [appExpandableText]="''" [maxLines]="1"></div>
  <div class="toolbar">
    <ion-segment [value]="viewMode" (ionChange)="setViewMode($any($event.detail.value))">
      <ion-segment-button
        value="chronology"
        [attr.aria-label]="'DOCUMENTS_FIELD.CHRONOLOGY_TOOLTIP' | translate"
        [title]="'DOCUMENTS_FIELD.CHRONOLOGY_TOOLTIP' | translate">
        <ion-label>{{ 'DOCUMENTS_FIELD.CHRONOLOGY' | translate }}</ion-label>
      </ion-segment-button>
      <ion-segment-button
        value="folders"
        [attr.aria-label]="'DOCUMENTS_FIELD.FOLDERS_TOOLTIP' | translate"
        [title]="'DOCUMENTS_FIELD.FOLDERS_TOOLTIP' | translate">
        <ion-label>{{ 'DOCUMENTS_FIELD.FOLDERS' | translate }}</ion-label>
      </ion-segment-button>
    </ion-segment>

    <div class="toolbar__search-row">
      <ion-searchbar
        class="search"
        [ngModel]="searchText"
        (ngModelChange)="onSearchChange($event)"
        [debounce]="250"
        [placeholder]="'DOCUMENTS_FIELD.SEARCH_PLACEHOLDER' | translate"
      ></ion-searchbar>

      @if (viewMode === 'chronology') {
        <button
          type="button"
          class="toolbar__filter-toggle"
          [class.toolbar__filter-toggle--active]="showChronologyFilters"
          [attr.aria-label]="'DOCUMENTS_FIELD.TOGGLE_FILTERS' | translate"
          [title]="'DOCUMENTS_FIELD.TOGGLE_FILTERS' | translate"
          (click)="toggleChronologyFilters()">
          <app-dynamic-icon name="fa-solid fa-filter"></app-dynamic-icon>
          @if (hasActiveChronologyFilters) {
            <span class="toolbar__filter-badge" aria-hidden="true"></span>
          }
          <span class="toolbar__filter-toggle-text">{{ 'DOCUMENTS_FIELD.TOGGLE_FILTERS' | translate }}</span>
        </button>
      }
    </div>
  </div>

  @if (canEdit) {
    <ion-card
      class="new-document-card"
      data-drop-kind="newDocument"
      [class.drop-target--active]="isDropTargetActive({ kind: 'newDocument' })"
      (dragover)="onDropZoneDragOver($event, { kind: 'newDocument' })"
      (dragleave)="onDropZoneDragLeave($event, { kind: 'newDocument' })"
      (drop)="onDropZoneDrop($event, { kind: 'newDocument' })">
      <ion-card-header>
        <ion-card-title>{{ 'DOCUMENTS_FIELD.ADD_DOCUMENT' | translate }}</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <div class="new-document-grid">
          <div class="field-row folder-tree-picker">
            <div class="field-label" #folderTreeLabel>{{ 'DOCUMENTS_FIELD.CATEGORY' | translate }} / {{ 'DOCUMENTS_FIELD.TYPE' | translate }}<span class="required">*</span></div>
            <div class="field-control field-control--with-validation">
            @if (folderTreeNodes.length === 0) {
              <div class="folder-tree-empty">{{ 'DOCUMENTS_FIELD.FOLDER_STRUCTURE_UNAVAILABLE' | translate }}</div>
            } @else if (isFolderTreeCollapsed) {
              <span
                class="folder-tree-summary"
                [class.folder-tree-summary--placeholder]="!hasValidFolderSelection()"
                [class.error]="shouldShowNewDocumentFieldError(isNewDocumentFolderSelectionInvalid())"
                (click)="expandFolderTree()">
                @if (hasValidFolderSelection()) {
                  {{ getSelectedFolderLabel() }}
                } @else {
                  {{ 'DOCUMENTS_FIELD.SELECT_FOLDER' | translate }}
                }
              </span>
            } @else {
              <div class="folder-tree-overlay" [class.error]="shouldShowNewDocumentFieldError(isNewDocumentFolderSelectionInvalid())">
                <tree-root
                  [nodes]="folderTreeNodes"
                  [(state)]="folderTreeState"
                  [options]="folderTreeOptions">
                  <ng-template #treeNodeWrapperTemplate let-node let-index="index">
                    <div class="body-row">
                      <div class="node-column">
                        <div class="node-wrapper-outer" [attr.data-level]="node.level" [attr.data-node-id]="node.id">
                          <div class="branch-lines"></div>
                          <div class="node-wrapper" [style.padding-left]="node.getNodePadding()">
                            <tree-node-expander [node]="node"></tree-node-expander>
                            <div
                              class="node"
                              [class.selected-node]="node.id === selectedFolderNodeId"
                              [class.disabled-node]="!canSelectFolderNode(node)"
                              (click)="node.mouseAction('click', $event)">
                              <span class="node-name">
                                <tree-node-content [node]="node" [index]="index"></tree-node-content>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </tree-root>
              </div>
            }
            @if (shouldShowNewDocumentFieldError(isNewDocumentFolderSelectionInvalid())) {
              <div class="validation-errors">
                <div class="validation-error">{{ 'ERRORS.REQUIRED' | translate }}</div>
              </div>
            }
            </div>
          </div>

          <div class="field-row">
            <div class="field-label">{{ 'DOCUMENTS_FIELD.FOLDER_NAME' | translate }}<span class="required">*</span></div>
            <div class="field-control field-control--with-validation">
              <input class="active-input" [class.error]="shouldShowNewDocumentFieldError(isNewDocumentFolderNameInvalid())" [(ngModel)]="newDocumentFolderName" (ngModelChange)="onNewDocumentFormFieldChange()" title="{{ 'DOCUMENTS_FIELD.FOLDER_NAME' | translate }}" />
              @if (shouldShowNewDocumentFieldError(isNewDocumentFolderNameInvalid())) {
                <div class="validation-errors">
                  <div class="validation-error">{{ 'ERRORS.REQUIRED' | translate }}</div>
                </div>
              }
            </div>
          </div>

          <div class="field-row">
            <div class="field-label">{{ 'DOCUMENTS_FIELD.DOCUMENT_NAME' | translate }}<span class="required">*</span></div>
            <div class="field-control field-control--with-validation">
              <input class="active-input" [class.error]="shouldShowNewDocumentFieldError(isNewDocumentNameInvalid())" [(ngModel)]="newDocumentName" (ngModelChange)="onNewDocumentFormFieldChange()" title="{{ 'DOCUMENTS_FIELD.DOCUMENT_NAME' | translate }}" />
              @if (shouldShowNewDocumentFieldError(isNewDocumentNameInvalid())) {
                <div class="validation-errors">
                  <div class="validation-error">{{ 'ERRORS.REQUIRED' | translate }}</div>
                </div>
              }
            </div>
          </div>

          <div class="field-row">
            <div class="field-label">{{ 'DOCUMENTS_FIELD.DOCUMENT_DATE' | translate }}<span class="required">*</span></div>
            <div class="field-control field-control--with-validation">
              <input class="active-input" type="date" [class.error]="shouldShowNewDocumentFieldError(isNewDocumentDateInvalid())" [(ngModel)]="newDocumentDate" (ngModelChange)="onFormFieldChange()" title="{{ 'DOCUMENTS_FIELD.DOCUMENT_DATE' | translate }}" />
              @if (shouldShowNewDocumentFieldError(isNewDocumentDateInvalid())) {
                <div class="validation-errors">
                  <div class="validation-error">{{ 'ERRORS.REQUIRED' | translate }}</div>
                </div>
              }
            </div>
          </div>

          <div class="field-row appendix-item">
            <div class="field-label">{{ 'DOCUMENTS_FIELD.APPENDIX' | translate }}</div>
            <div class="field-control">
              <ion-checkbox [(ngModel)]="newDocumentAppendix"></ion-checkbox>
            </div>
          </div>
        </div>

        <div class="field-row">
          <div class="field-label">{{ 'DOCUMENTS_FIELD.DESCRIPTION' | translate }}</div>
          <div class="field-control">
            <textarea class="active-input" [(ngModel)]="newDocumentDescription" title="{{ 'DOCUMENTS_FIELD.DESCRIPTION' | translate }}"></textarea>
          </div>
        </div>

        <div class="upload-row">
          <input #newDocFileInput [attr.aria-label]="'DOCUMENTS_FIELD.ATTACH_FILES' | translate" title="Attach files" type="file" multiple (change)="onFilesSelected($event)" />
          <ion-button fill="outline" size="small" (click)="newDocFileInput.click()">{{ 'DOCUMENTS_FIELD.ATTACH_FILES' | translate }}</ion-button>
          <span class="upload-count">{{ newDocumentSelectedFiles.length }} {{ 'DOCUMENTS_FIELD.FILES_SUFFIX' | translate }}</span>
        </div>

        @if (newDocumentSelectedFiles.length > 0) {
          <div class="media-chips">
            @for (file of newDocumentSelectedFiles; track file; let i = $index) {
              <ion-chip>
                <ion-label>{{ file.name }}</ion-label>
                <app-dynamic-icon
                  name="close"
                  (click)="removeNewMedia(i)"
                  [appTooltip]="'DOCUMENTS_FIELD.REMOVE_FILE' | translate"
                  tooltipPosition="top">
                </app-dynamic-icon>
                <!-- <ion-icon name="close" (click)="removeNewMedia(i)"></ion-icon> -->
              </ion-chip>
            }
          </div>
        }

        <div class="add-actions">
          <ion-button [disabled]="!canAddDocument()" (click)="addDocument()">{{ 'COMMON.ADD' | translate }}</ion-button>
        </div>
      </ion-card-content>
    </ion-card>
  }

  @if (viewMode === 'chronology') { 
    @if(showChronologyFilters) {
      <ion-card class="filters-card">
        <ion-card-content>
          <div class="filters-grid">
            <ion-item>
              <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.FROM' | translate }}</ion-label>
              <ion-input type="date" [(ngModel)]="chronologyFromDate" (ngModelChange)="onChronologyFilterChange()"></ion-input>
            </ion-item>
            <ion-item>
              <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.TO' | translate }}</ion-label>
              <ion-input type="date" [(ngModel)]="chronologyToDate" (ngModelChange)="onChronologyFilterChange()"></ion-input>
            </ion-item>
            <ion-item>
              <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.CATEGORY' | translate }}</ion-label>
              <ion-select [(ngModel)]="chronologyCategoryFilter" (ionChange)="onChronologyFilterChange()">
                <ion-select-option value="">{{ 'DOCUMENTS_FIELD.ALL' | translate }}</ion-select-option>
                @for (category of categoryOptions; track category.id) {
                  <ion-select-option [value]="category.id">{{ category.text }}</ion-select-option>
                }
              </ion-select>
            </ion-item>
            <ion-item>
              <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.TYPE' | translate }}</ion-label>
              <ion-select [(ngModel)]="chronologyTypeFilter" (ionChange)="onChronologyFilterChange()">
                <ion-select-option value="">{{ 'DOCUMENTS_FIELD.ALL' | translate }}</ion-select-option>
                @for (type of typeOptions; track type.id) {
                  <ion-select-option [value]="type.id">{{ type.text }}</ion-select-option>
                }
              </ion-select>
            </ion-item>
          </div>
        </ion-card-content>
      </ion-card>
    }
    
    <div class="chronology-list">
      @if (chronologyDocuments.length === 0) {
        <ion-card>
          <ion-card-content>{{ 'DOCUMENTS_FIELD.NO_DOCUMENTS_FOR_FILTERS' | translate }}</ion-card-content>
        </ion-card>
      }

      @for (doc of chronologyDocuments; track trackByDocument($index, doc)) {
        <div
          class="bubble-row"
          data-drop-kind="document"
          [attr.data-drop-document-id]="doc.id"
          [class.mine]="isMine(doc)"
          [class.drop-target--active]="isDropTargetActive({ kind: 'document', documentId: doc.id })"
          (dragover)="onDropZoneDragOver($event, { kind: 'document', documentId: doc.id })"
          (dragleave)="onDropZoneDragLeave($event, { kind: 'document', documentId: doc.id })"
          (drop)="onDropZoneDrop($event, { kind: 'document', documentId: doc.id })">
          <button
            type="button"
            class="bubble"
            [class]="'bubble ' + getCategoryBubbleClass(doc.folderCategory)"
            (click)="openDocumentDetails(doc)"
          >
            <div class="bubble-head">
              <span class="bubble-title">
                <app-dynamic-icon
                  class="doc-reminder-icon"
                  [class]="'doc-reminder-icon ' + getReminderToneClassForDocument(doc)"
                  [appTooltip]="getReminderTooltip(doc)"
                  tooltipPosition="top"
                  [name]="(isReminderDue(doc) ? 'fa-solid' : 'fa-regular') + ' fa-bell'">
                </app-dynamic-icon>
                {{doc.folderName}} ◆ {{ doc.documentName }}
              </span>
              <div class="bubble-head-right">
                <span class="bubble-date">{{ formatDateTime(doc.documentEntryDate) }}</span>
                <span class="bubble-user-id">{{ 'DOCUMENTS_FIELD.BY_USER_NAME' | translate }}: {{ doc.userFriendlyName || doc.userId }}</span>
              </div>
            </div>
            <div class="bubble-meta">
              {{ getCategoryText(doc.folderCategory) }} · {{ getTypeText(doc.folderCategory, doc.folderType) }}
            </div>
            @if (doc.documentDescription) {
              <div class="bubble-description" appExpandableText [appExpandableText]="doc.documentDescription" [allowHtml]="true" [maxLines]="10"></div>
            }
            @if (getAttachmentCount(doc) > 0) {
              <div class="media-preview-row">
                @for (attachment of getPreviewAttachments(doc); track attachment.id) {
                  @if (isImageMedia(attachment.mediaType)) {
                    @if (attachment.isExisting) {
                      <img appTooltip="{{attachment.name}}" tooltipPosition="top"
                        class="media-preview-thumb"
                        [src]="(attachment.fileId || '') | httpImgSrc"
                        [alt]="attachment.name"
                        (click)="openAttachment(doc, attachment, $event)"
                      />
                    } @else {
                      <img  appTooltip="{{attachment.name}}" tooltipPosition="top"
                        class="media-preview-thumb"
                        [src]="getSelectedFilePreview(attachment.file!)"
                        [alt]="attachment.name"
                        (click)="openAttachment(doc, attachment, $event)"
                      />
                    }
                  } @else if (isPdfMedia(attachment.mediaType) || isEmailMedia(attachment.mediaType, attachment.name)) {
                    <div class="media-preview-badge" (click)="openAttachment(doc, attachment, $event)" appTooltip="{{attachment.name}}" tooltipPosition="top">
                      <app-dynamic-icon [name]="getMediaBadgeIcon({ originalname: attachment.name, mediaType: attachment.mediaType }) || ''"></app-dynamic-icon>
                    </div>
                  } @else {
                    <div class="media-preview-badge" (click)="openAttachment(doc, attachment, $event)" appTooltip="{{attachment.name}}" tooltipPosition="top">
                      <!-- {{ getMediaBadgeLabel({ fileId: attachment.fileId || '', originalname: attachment.name, mediaType: attachment.mediaType }) }} -->
                      <app-dynamic-icon name="fa-regular fa-file"></app-dynamic-icon>
                    </div>
                  }
                }
                @if (hasMoreMedia(doc)) {
                  <div class="media-preview-more">+{{ getAttachmentCount(doc) - 3 }}</div>
                }
              </div>
              <div class="bubble-files">{{ getAttachmentCount(doc) }} {{ 'DOCUMENTS_FIELD.ATTACHMENTS_SUFFIX' | translate }}</div>
            }
          </button>
        </div>
      }
    </div>
  }

  @if (viewMode === 'folders') {
    <div class="folder-view">
      @if (folderTree.length === 0) {
        <ion-card>
          <ion-card-content>{{ 'DOCUMENTS_FIELD.FOLDER_STRUCTURE_UNAVAILABLE' | translate }}</ion-card-content>
        </ion-card>
      }

      @if (folderTree.length > 0 && !hasVisibleFolders()) {
        <ion-card>
          <ion-card-content>{{ 'DOCUMENTS_FIELD.NO_DOCUMENTS_IN_FOLDERS' | translate }}</ion-card-content>
        </ion-card>
      }

      @for (category of folderTree; track trackByCategory($index, category)) {
        @if (getNonEmptyCategoryChildren(category).length > 0) {
          <ion-card
            class="category-card"
            data-drop-kind="category"
            [attr.data-drop-category-id]="category.id"
            [class.drop-target--active]="isDropTargetActive({ kind: 'category', categoryId: category.id })"
            (dragover)="onDropZoneDragOver($event, { kind: 'category', categoryId: category.id })"
            (dragleave)="onDropZoneDragLeave($event, { kind: 'category', categoryId: category.id })"
            (drop)="onDropZoneDrop($event, { kind: 'category', categoryId: category.id })">
            <ion-card-header>
              <ion-card-title>{{ category.text }}</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <div class="folder-types-grid">
                @for (typeNode of getVisibleCategoryChildren(category); track trackByFolderType($index, typeNode)) {
                  <div
                    class="folder-type-card"
                    data-drop-kind="folderType"
                    [attr.data-drop-category-id]="category.id"
                    [attr.data-drop-type-id]="typeNode.id"
                    [class.drop-target--active]="isDropTargetActive({ kind: 'folderType', categoryId: category.id, typeId: typeNode.id })"
                    (dragover)="onDropZoneDragOver($event, { kind: 'folderType', categoryId: category.id, typeId: typeNode.id })"
                    (dragleave)="onDropZoneDragLeave($event, { kind: 'folderType', categoryId: category.id, typeId: typeNode.id })"
                    (drop)="onDropZoneDrop($event, { kind: 'folderType', categoryId: category.id, typeId: typeNode.id })">
                    <div class="folder-type-head">
                      <div class="folder-type-title">{{ typeNode.text }}</div>
                    </div>

                    @for (folderGroup of getFolderNameGroupsForType(category.id, typeNode.id); track trackByFolderName($index, folderGroup)) {
                      <div
                        [class.folder-name-card]="shouldShowFolderNameLayer(folderGroup)"
                        data-drop-kind="folderName"
                        [attr.data-drop-category-id]="category.id"
                        [attr.data-drop-type-id]="typeNode.id"
                        [attr.data-drop-folder-name]="folderGroup.folderName"
                        [class.drop-target--active]="shouldShowFolderNameLayer(folderGroup) && isDropTargetActive({ kind: 'folderName', categoryId: category.id, typeId: typeNode.id, folderName: folderGroup.folderName })"
                        (dragover)="shouldShowFolderNameLayer(folderGroup) && onDropZoneDragOver($event, { kind: 'folderName', categoryId: category.id, typeId: typeNode.id, folderName: folderGroup.folderName })"
                        (dragleave)="shouldShowFolderNameLayer(folderGroup) && onDropZoneDragLeave($event, { kind: 'folderName', categoryId: category.id, typeId: typeNode.id, folderName: folderGroup.folderName })"
                        (drop)="shouldShowFolderNameLayer(folderGroup) && onDropZoneDrop($event, { kind: 'folderName', categoryId: category.id, typeId: typeNode.id, folderName: folderGroup.folderName })">
                        @if (shouldShowFolderNameLayer(folderGroup)) {
                        <div class="folder-name-title">
                          @if (folderGroup.folderName) {
                            {{ folderGroup.folderName }}
                          } @else {
                            {{ 'DOCUMENTS_FIELD.UNNAMED_FOLDER' | translate }}
                          }
                        </div>
                        }

                        @for (doc of getVisibleDocumentsForFolderName(category.id, typeNode.id, folderGroup.folderName); track trackByDocument($index, doc)) {
                      <div
                        class="folder-doc"
                        data-drop-kind="document"
                        [attr.data-drop-document-id]="doc.id"
                        [class.drop-target--active]="isDropTargetActive({ kind: 'document', documentId: doc.id })"
                        (dragover)="onDropZoneDragOver($event, { kind: 'document', documentId: doc.id })"
                        (dragleave)="onDropZoneDragLeave($event, { kind: 'document', documentId: doc.id })"
                        (drop)="onDropZoneDrop($event, { kind: 'document', documentId: doc.id })">
                        <button type="button" class="folder-doc-main" (click)="openDocumentDetails(doc)">
                          <div class="doc-head">
                            <div class="doc-head-left">
                              @if(doc.appendix) {
                                <div class="doc-appendix">
                                  <app-dynamic-icon name="fa-solid fa-paperclip"></app-dynamic-icon>
                                </div>
                              }
                              <app-dynamic-icon
                                class="doc-reminder-icon"
                                [class]="'doc-reminder-icon ' + getReminderToneClassForDocument(doc)"
                                [appTooltip]="getReminderTooltip(doc)"
                                tooltipPosition="top"
                                [name]="(isReminderDue(doc) ? 'fa-solid' : 'fa-regular') + ' fa-bell'">
                              </app-dynamic-icon>
                              <div class="doc-name">{{ doc.documentName }}</div>
                            </div>
                            <div class="doc-head-right">
                              <div class="doc-date">{{ formatDateTime(doc.documentEntryDate) }}</div>
                              <div class="doc-user-id">{{ 'DOCUMENTS_FIELD.BY_USER_NAME' | translate }}: {{ doc.userFriendlyName || doc.userId }}</div>
                            </div>
                          </div>
                          @if (doc.documentDescription) {
                            <div class="doc-description" appExpandableText [appExpandableText]="doc.documentDescription" [allowHtml]="true" [maxLines]="10"></div>
                          }
                          @if (getAttachmentCount(doc) > 0) {
                            <div class="media-preview-row">
                              @for (attachment of getPreviewAttachments(doc); track attachment.id) {
                                @if (isImageMedia(attachment.mediaType)) {
                                  @if (attachment.isExisting) {
                                    <img
                                      class="media-preview-thumb"
                                      [src]="(attachment.fileId || '') | httpImgSrc"
                                      [alt]="attachment.name"
                                      (click)="openAttachment(doc, attachment, $event)"
                                    />
                                  } @else {
                                    <img
                                      class="media-preview-thumb"
                                      [src]="getSelectedFilePreview(attachment.file!)"
                                      [alt]="attachment.name"
                                      (click)="openAttachment(doc, attachment, $event)"
                                    />
                                  }
                                } @else if (isPdfMedia(attachment.mediaType) || isEmailMedia(attachment.mediaType, attachment.name)) {
                                  <div class="media-preview-badge" (click)="openAttachment(doc, attachment, $event)">
                                    <app-dynamic-icon [name]="getMediaBadgeIcon({ originalname: attachment.name, mediaType: attachment.mediaType }) || ''"></app-dynamic-icon>
                                  </div>
                                } @else {
                                  <div class="media-preview-badge">
                                    {{ getMediaBadgeLabel({ fileId: attachment.fileId || '', originalname: attachment.name, mediaType: attachment.mediaType }) }}
                                  </div>
                                }
                              }
                              @if (hasMoreMedia(doc)) {
                                <div class="media-preview-more">+{{ getAttachmentCount(doc) - 3 }}</div>
                              }
                            </div>
                          }
                        </button>
                        @if (canEdit) {
                          <div class="folder-doc-actions">
                            <ion-select
                              interface="popover"
                              [value]="doc.folderType"
                              (ionChange)="moveDocument(doc.id, category.id, $any($event.detail.value))"
                            >
                              @for (type of getTypesForCategory(category.id); track type.id) {
                                <ion-select-option [value]="type.id">{{ type.text }}</ion-select-option>
                              }
                            </ion-select>
                          </div>
                        }
                      </div>
                    }

                        @if (shouldShowFolderNameLayer(folderGroup) && canShowMoreDocumentsForFolderName(category.id, typeNode.id, folderGroup.folderName)) {
                          <ion-button fill="clear" size="small" (click)="showMoreDocumentsForFolderName(category.id, typeNode.id, folderGroup.folderName)">
                            {{ 'DOCUMENTS_FIELD.MORE_DOCUMENTS' | translate }}
                          </ion-button>
                        }
                      </div>
                    }

                  </div>
                }
              </div>

              @if (canShowMoreCategoryChildren(category)) {
                <ion-button fill="clear" size="small" (click)="showMoreCategoryChildren(category.id)">
                  {{ 'DOCUMENTS_FIELD.MORE_SUBFOLDERS' | translate }}
                </ion-button>
              }
            </ion-card-content>
          </ion-card>
        }
      }
    </div>
  }

  @if (isDetailModalOpen) {
    <div class="modal-document">
      <div
        #detailModalDialog
        class="modal-document__dialog"
        role="dialog"
        aria-modal="true"
        tabindex="-1"
        (click)="$event.stopPropagation()"
        (keydown)="onDetailModalKeydown($event)">
        <div class="modal-document__header">
          <div class="modal-document__title">{{ 'DOCUMENTS_FIELD.DOCUMENT_DETAILS' | translate }}</div>
          <div class="modal-document__header-actions">
            @if (canEdit && selectedDocument) {
              <ion-button size="small" [disabled]="!canSaveDocumentDetails()" (click)="saveDocumentDetails()">{{ 'COMMON.SAVE' | translate }}</ion-button>
              <ion-button fill="clear" color="danger" size="small" (click)="deleteDocument(selectedDocument.id, $event)">{{ 'COMMON.DELETE' | translate }}</ion-button>
            }
            <ion-button fill="clear" size="small" (click)="requestCloseDocumentDetails()">{{ 'COMMON.CLOSE' | translate }}</ion-button>
          </div>
        </div>
        <div class="modal-document__body">
          @if (selectedDocumentDraft) {
            <div class="detail-grid">
            @if (canEdit) {
              @if (selectedDocumentDraft.folderCategory) {
                <ion-item lines="none" class="modal-readonly-item">
                  <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.CATEGORY' | translate }}</ion-label>
                  <div class="modal-readonly-value">{{ getCategoryText(selectedDocumentDraft.folderCategory) }}</div>
                </ion-item>
              }

              <div class="field-row folder-tree-picker modal-folder-tree-picker">
                <div class="field-label">
                  @if (selectedDocumentDraft.folderCategory) {
                    {{ 'DOCUMENTS_FIELD.TYPE' | translate }}<span class="required">*</span>
                  } @else {
                    {{ 'DOCUMENTS_FIELD.CATEGORY' | translate }} / {{ 'DOCUMENTS_FIELD.TYPE' | translate }}<span class="required">*</span>
                  }
                </div>
                <div class="field-control field-control--with-validation">
                  @if (getFolderPickerNodes('detail').length === 0) {
                    <div class="folder-tree-empty">{{ 'DOCUMENTS_FIELD.FOLDER_STRUCTURE_UNAVAILABLE' | translate }}</div>
                  } @else if (isFolderPickerCollapsed('detail') && hasValidFolderPickerSelection(selectedDocumentDraft.folderCategory, selectedDocumentDraft.folderType)) {
                    <span class="folder-tree-summary" (click)="expandFolderPicker('detail')">
                      {{ getFolderPickerLabel(selectedDocumentDraft.folderCategory, selectedDocumentDraft.folderType) }}
                    </span>
                  } @else {
                    <div class="modal-folder-tree-panel" [class.error]="isDetailFolderSelectionInvalid()">
                      <tree-root
                        [nodes]="getFolderPickerNodes('detail')"
                        [(state)]="folderPickers.detail.treeState"
                        [options]="detailFolderTreeOptions">
                        <ng-template #treeNodeWrapperTemplate let-node let-index="index">
                          <div class="body-row">
                            <div class="node-column">
                              <div class="node-wrapper-outer" [attr.data-level]="node.level" [attr.data-node-id]="node.id">
                                <div class="branch-lines"></div>
                                <div class="node-wrapper" [style.padding-left]="node.getNodePadding()">
                                  <tree-node-expander [node]="node"></tree-node-expander>
                                  <div
                                    class="node"
                                    [class.selected-node]="isFolderPickerNodeSelected('detail', node)"
                                    [class.disabled-node]="!canSelectFolderNode(node)"
                                    (click)="node.mouseAction('click', $event)">
                                    <span class="node-name">
                                      <tree-node-content [node]="node" [index]="index"></tree-node-content>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </tree-root>
                    </div>
                  }
                  @if (isDetailFolderSelectionInvalid()) {
                    <div class="validation-errors">
                      <div class="validation-error">{{ 'ERRORS.REQUIRED' | translate }}</div>
                    </div>
                  }
                </div>
              </div>
            } @else {
              <ion-item lines="none" class="modal-readonly-item">
                <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.CATEGORY' | translate }}</ion-label>
                <div class="modal-readonly-value">{{ getCategoryText(selectedDocumentDraft.folderCategory) }}</div>
              </ion-item>
              <ion-item lines="none" class="modal-readonly-item">
                <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.TYPE' | translate }}</ion-label>
                <div class="modal-readonly-value">{{ getTypeText(selectedDocumentDraft.folderCategory, selectedDocumentDraft.folderType) }}</div>
              </ion-item>
            }

            <div class="modal-field">
              <ion-item class="modal-input-item">
                <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.DOCUMENT_NAME' | translate }}<span class="required">*</span></ion-label>
                <div class="modal-input-wrap" [class.error]="isDetailDocumentNameInvalid()">
                  <ion-input [readonly]="!canEdit" [(ngModel)]="selectedDocumentDraft.documentName" (ngModelChange)="onFormFieldChange()"></ion-input>
                </div>
              </ion-item>
              @if (isDetailDocumentNameInvalid()) {
                <div class="validation-errors modal-field-validation">
                  <div class="validation-error">{{ 'ERRORS.REQUIRED' | translate }}</div>
                </div>
              }
            </div>

            <div class="modal-field">
              <ion-item class="modal-input-item">
                <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.DOCUMENT_DATE' | translate }}<span class="required">*</span></ion-label>
                <div class="modal-input-wrap" [class.error]="isDetailDocumentDateInvalid()">
                  <ion-input [readonly]="!canEdit" type="date" [(ngModel)]="selectedDocumentDraft.documentDate" (ngModelChange)="onFormFieldChange()"></ion-input>
                </div>
              </ion-item>
              @if (isDetailDocumentDateInvalid()) {
                <div class="validation-errors modal-field-validation">
                  <div class="validation-error">{{ 'ERRORS.REQUIRED' | translate }}</div>
                </div>
              }
            </div>

            <div class="modal-field">
              <ion-item class="modal-input-item">
                <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.FOLDER_NAME' | translate }}<span class="required">*</span></ion-label>
                <div class="modal-input-wrap" [class.error]="isDetailFolderNameInvalid()">
                  <ion-input [readonly]="!canEdit" [(ngModel)]="selectedDocumentDraft.folderName" (ngModelChange)="onFormFieldChange()"></ion-input>
                </div>
              </ion-item>
              @if (isDetailFolderNameInvalid()) {
                <div class="validation-errors modal-field-validation">
                  <div class="validation-error">{{ 'ERRORS.REQUIRED' | translate }}</div>
                </div>
              }
            </div>

            <ion-item lines="none" class="appendix-item modal-input-item">
              <ion-label>{{ 'DOCUMENTS_FIELD.APPENDIX' | translate }}</ion-label>
              <ion-checkbox slot="end" [disabled]="!canEdit" [(ngModel)]="selectedDocumentDraft.appendix"></ion-checkbox>
            </ion-item>

            <ion-item class="modal-input-item">
              <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.DESCRIPTION' | translate }}</ion-label>
              @if (canEdit) {
                <ion-textarea autoGrow="true" [(ngModel)]="selectedDocumentDraft.documentDescription"></ion-textarea>
              } @else {
                <div class="detail-description" [innerHTML]="sanitizeDocumentDescription(selectedDocumentDraft.documentDescription)"></div>
              }
            </ion-item>

            <div class="detail-meta">{{ 'DOCUMENTS_FIELD.ENTRY_DATE' | translate }}: {{ formatDateTime(selectedDocumentDraft.documentEntryDate) }}</div>
            <div class="detail-meta">{{ 'DOCUMENTS_FIELD.BY_USER_NAME' | translate }}: {{ selectedDocumentDraft.userFriendlyName || selectedDocumentDraft.userId }}</div>

            @if (canShowReminders(selectedDocumentDraft)) {
              <div class="detail-reminders">
                <app-claim-document-reminders
                  [claimId]="selectedDocumentDraft ? getCurrentClaimId() : ''"
                  [documentId]="selectedDocumentDraft.id"
                  [baseDate]="selectedDocumentDraft.documentDate"
                  [reminders]="reminders"
                  [readonly]="!canEdit"
                  (remindersChange)="onDocumentRemindersChange($event)">
                </app-claim-document-reminders>
              </div>
            } @else if (getReminderAvailabilityMessage(selectedDocumentDraft)) {
              <div class="detail-reminder-note">
                <ion-note color="medium">{{ getReminderAvailabilityMessage(selectedDocumentDraft) | translate }}</ion-note>
              </div>
            }

            @if (canEdit) {
              <div class="upload-row">
                <input #detailDocFileInput [attr.aria-label]="'DOCUMENTS_FIELD.ATTACH_FILES' | translate" title="Attach files" type="file" multiple (change)="onDetailFilesSelected($event)" />
                <ion-button fill="outline" size="small" (click)="detailDocFileInput.click()">{{ 'DOCUMENTS_FIELD.ATTACH_FILES' | translate }}</ion-button>
                <span class="upload-count">{{ getAttachmentCount(selectedDocumentDraft) }} {{ 'DOCUMENTS_FIELD.FILES_SUFFIX' | translate }}</span>
              </div>
            }

            @if (getAttachmentCount(selectedDocumentDraft) > 0) {
              <div class="media-list">
                @for (attachment of getAllAttachments(selectedDocumentDraft); track attachment.id; let i = $index) {
                  <ion-chip class="media-list__chip" (click)="openAttachment(selectedDocumentDraft, attachment, $event)">
                    <ion-label>{{ attachment.name }}</ion-label>
                    @if (canEdit) {
                      <app-dynamic-icon
                        name="close"
                        class="remove-media-icon"
                        (click)="attachment.isExisting ? removeDetailMedia(i) : removeDetailSelectedFile(i - selectedDocumentDraft.media.length); $event.stopPropagation()">
                      </app-dynamic-icon>
                    }
                  </ion-chip>
                }
              </div>
            }
            </div>
          }
        </div>
      </div>

      @if (isDiscardConfirmOpen) {
        <div class="modal-document__confirm-backdrop" (click)="cancelDiscardConfirm(); $event.stopPropagation()">
          <div
            #discardConfirmDialog
            class="modal-document__confirm-dialog"
            role="alertdialog"
            aria-modal="true"
            tabindex="-1"
            (click)="$event.stopPropagation()"
            (keydown)="onDetailModalKeydown($event)">
            <div class="modal-document__confirm-title">{{ 'DOCUMENTS_FIELD.DISCARD_TITLE' | translate }}</div>
            <div class="modal-document__confirm-message">{{ 'DOCUMENTS_FIELD.DISCARD_MESSAGE' | translate }}</div>
            <div class="modal-document__confirm-actions">
              <ion-button fill="clear" (click)="cancelDiscardConfirm(); $event.stopPropagation()">{{ 'COMMON.CANCEL' | translate }}</ion-button>
              <ion-button color="danger" (click)="confirmDiscardDocumentDetails(); $event.stopPropagation()">{{ 'DOCUMENTS_FIELD.DISCARD_ACTION' | translate }}</ion-button>
            </div>
          </div>
        </div>
      }
    </div>
  }

  @if (isDropCreateModalOpen && dropCreateDraft) {
    <div class="modal-document">
      <div
        class="modal-document__dialog"
        role="dialog"
        aria-modal="true"
        tabindex="-1"
        (click)="$event.stopPropagation()">
        <div class="modal-document__header">
          <div class="modal-document__title">{{ 'DOCUMENTS_FIELD.DROP_CREATE_TITLE' | translate }}</div>
          <div class="modal-document__header-actions">
            <ion-button size="small" [disabled]="!canConfirmDropCreate()" (click)="confirmDropCreate()">{{ 'COMMON.ADD' | translate }}</ion-button>
            <ion-button fill="clear" size="small" (click)="closeDropCreateModal()">{{ 'COMMON.CANCEL' | translate }}</ion-button>
          </div>
        </div>
        <div class="modal-document__body">
          <div class="detail-grid">
            @if (dropCreateContext?.kind === 'folderName') {
              <ion-item lines="none" class="modal-readonly-item">
                <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.CATEGORY' | translate }}</ion-label>
                <div class="modal-readonly-value">{{ getCategoryText(dropCreateDraft.folderCategory) }}</div>
              </ion-item>
              <ion-item lines="none" class="modal-readonly-item">
                <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.TYPE' | translate }}</ion-label>
                <div class="modal-readonly-value">{{ getTypeText(dropCreateDraft.folderCategory, dropCreateDraft.folderType) }}</div>
              </ion-item>
              @if (shouldShowDropCreateFolderNameReadonly()) {
                <ion-item lines="none" class="modal-readonly-item">
                  <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.FOLDER_NAME' | translate }}<span class="required">*</span></ion-label>
                  <div class="modal-readonly-value">{{ dropCreateDraft.folderName }}</div>
                </ion-item>
              }
            }

            @if (shouldShowFolderPickerInDropModal()) {
              @if (getDropCreateLockedCategoryId()) {
                <ion-item lines="none" class="modal-readonly-item">
                  <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.CATEGORY' | translate }}</ion-label>
                  <div class="modal-readonly-value">{{ getCategoryText(dropCreateDraft.folderCategory) }}</div>
                </ion-item>
              }

              <div class="field-row folder-tree-picker modal-folder-tree-picker">
                <div class="field-label">
                  @if (getDropCreateLockedCategoryId()) {
                    {{ 'DOCUMENTS_FIELD.TYPE' | translate }}<span class="required">*</span>
                  } @else {
                    {{ 'DOCUMENTS_FIELD.CATEGORY' | translate }} / {{ 'DOCUMENTS_FIELD.TYPE' | translate }}<span class="required">*</span>
                  }
                </div>
                <div class="field-control field-control--with-validation">
                  @if (getFolderPickerNodes('dropCreate').length === 0) {
                    <div class="folder-tree-empty">{{ 'DOCUMENTS_FIELD.FOLDER_STRUCTURE_UNAVAILABLE' | translate }}</div>
                  } @else if (isFolderPickerCollapsed('dropCreate') && hasValidFolderPickerSelection(dropCreateDraft.folderCategory, dropCreateDraft.folderType)) {
                    <span class="folder-tree-summary" (click)="expandFolderPicker('dropCreate')">
                      {{ getFolderPickerLabel(dropCreateDraft.folderCategory, dropCreateDraft.folderType) }}
                    </span>
                  } @else {
                    <div class="modal-folder-tree-panel" [class.error]="isDropCreateFolderSelectionInvalid()">
                      <tree-root
                        [nodes]="getFolderPickerNodes('dropCreate')"
                        [(state)]="folderPickers.dropCreate.treeState"
                        [options]="dropCreateFolderTreeOptions">
                        <ng-template #treeNodeWrapperTemplate let-node let-index="index">
                          <div class="body-row">
                            <div class="node-column">
                              <div class="node-wrapper-outer" [attr.data-level]="node.level" [attr.data-node-id]="node.id">
                                <div class="branch-lines"></div>
                                <div class="node-wrapper" [style.padding-left]="node.getNodePadding()">
                                  <tree-node-expander [node]="node"></tree-node-expander>
                                  <div
                                    class="node"
                                    [class.selected-node]="isFolderPickerNodeSelected('dropCreate', node)"
                                    [class.disabled-node]="!canSelectFolderNode(node)"
                                    (click)="node.mouseAction('click', $event)">
                                    <span class="node-name">
                                      <tree-node-content [node]="node" [index]="index"></tree-node-content>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </tree-root>
                    </div>
                  }
                  @if (isDropCreateFolderSelectionInvalid()) {
                    <div class="validation-errors">
                      <div class="validation-error">{{ 'ERRORS.REQUIRED' | translate }}</div>
                    </div>
                  }
                </div>
              </div>
            }

            @if (shouldShowDropCreateFolderNameInput()) {
              <div class="modal-field">
                <ion-item class="modal-input-item">
                  <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.FOLDER_NAME' | translate }}<span class="required">*</span></ion-label>
                  <div class="modal-input-wrap" [class.error]="isDropCreateFolderNameInvalid()">
                    <ion-input [(ngModel)]="dropCreateDraft.folderName" (ngModelChange)="onFormFieldChange()"></ion-input>
                  </div>
                </ion-item>
                @if (isDropCreateFolderNameInvalid()) {
                  <div class="validation-errors modal-field-validation">
                    <div class="validation-error">{{ 'ERRORS.REQUIRED' | translate }}</div>
                  </div>
                }
              </div>
            }

            <div class="modal-field">
              <ion-item class="modal-input-item">
                <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.DOCUMENT_NAME' | translate }}<span class="required">*</span></ion-label>
                <div class="modal-input-wrap" [class.error]="isDropCreateDocumentNameInvalid()">
                  <ion-input [(ngModel)]="dropCreateDraft.documentName" (ngModelChange)="onFormFieldChange()"></ion-input>
                </div>
              </ion-item>
              @if (isDropCreateDocumentNameInvalid()) {
                <div class="validation-errors modal-field-validation">
                  <div class="validation-error">{{ 'ERRORS.REQUIRED' | translate }}</div>
                </div>
              }
            </div>

            <div class="modal-field">
              <ion-item class="modal-input-item">
                <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.DOCUMENT_DATE' | translate }}<span class="required">*</span></ion-label>
                <div class="modal-input-wrap" [class.error]="isDropCreateDocumentDateInvalid()">
                  <ion-input type="date" [(ngModel)]="dropCreateDraft.documentDate" (ngModelChange)="onFormFieldChange()"></ion-input>
                </div>
              </ion-item>
              @if (isDropCreateDocumentDateInvalid()) {
                <div class="validation-errors modal-field-validation">
                  <div class="validation-error">{{ 'ERRORS.REQUIRED' | translate }}</div>
                </div>
              }
            </div>

            <ion-item lines="none" class="appendix-item modal-input-item">
              <ion-label>{{ 'DOCUMENTS_FIELD.APPENDIX' | translate }}</ion-label>
              <ion-checkbox slot="end" [(ngModel)]="dropCreateDraft.appendix"></ion-checkbox>
            </ion-item>

            <ion-item class="modal-input-item">
              <ion-label position="stacked">{{ 'DOCUMENTS_FIELD.DESCRIPTION' | translate }}</ion-label>
              <ion-textarea autoGrow="true" [(ngModel)]="dropCreateDraft.documentDescription"></ion-textarea>
            </ion-item>
          </div>

          <div class="media-list">
            <div class="media-list__title">{{ 'DOCUMENTS_FIELD.ATTACH_FILES' | translate }}</div>
            <div class="media-chips">
              @for (file of dropCreateDraft.files; track file; let i = $index) {
                <ion-chip>
                  <ion-label>{{ file.name }}</ion-label>
                  <app-dynamic-icon
                    name="close"
                    class="remove-media-icon"
                    (click)="removeDropCreateFile(i)">
                  </app-dynamic-icon>
                </ion-chip>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>